// extracted by mini-css-extract-plugin
export default {"buttons":"m41k6F","container":"Wo1xzX","badBoyImage":"JYacbO","errorMessage":"gllfrZ"};